import React, { useState, useEffect } from 'react';
import { CheckCircle2, AlertCircle, Send, Clock, FileText, XCircle, Download } from 'lucide-react';
import api from '../services/api';
import { useRealtimeNotifications } from '../hooks/useRealtimeNotifications';

// ⭐ NOVO: tela operacional pro atendente enviar contratos/documentos pra
// assinatura eletrônica (Clicksign). A configuração do Access Token continua
// só em Integração BI (admin/gerente) — aqui é só o envio do dia a dia.
function Envios() {
  // ⭐ NOVO: escuta notificações em tempo real — quando um documento é assinado,
  // recarrega a lista sozinha (o som/aviso do navegador já toca automaticamente,
  // cuidado pelo próprio hook, sem precisar de nada a mais aqui)
  const { notifications } = useRealtimeNotifications();
  const [esignConfig, setEsignConfig] = useState(null);
  const [loadingConfig, setLoadingConfig] = useState(true);
  const [esignFile, setEsignFile] = useState(null);
  const [esignSigners, setEsignSigners] = useState([
    { key: 'signer-1', deliveryType: 'email', name: '', email: '', phone: '', documentation: '', birthday: '' }
  ]);
  const [sendingDoc, setSendingDoc] = useState(false);
  // ⭐ NOVO: permissão individual desse usuário (controlada pelo admin em Usuários)
  const [canAccess, setCanAccess] = useState(true);
  // ⭐ NOVO: histórico de envios com status (pendente/assinado)
  const [sentDocs, setSentDocs] = useState([]);
  const [loadingList, setLoadingList] = useState(true);

  // ⭐ NOVO: qual aba está ativa nessa tela — formulário ou upload de arquivo pronto
  const [envioTab, setEnvioTab] = useState('form');

  // ⭐ NOVO: formulário de preenchimento de Contrato + Autorização (em etapas)
  const [contractStep, setContractStep] = useState(1);
  const [contractFields, setContractFields] = useState({
    plano_nome: '', plano_data_nascimento: '', plano_cpf: '', plano_rg: '', plano_orgao_emissor: '',
    plano_cep: '', plano_cidade: '', plano_endereco: '', plano_bairro: '', plano_celular: '', plano_email: '', plano_estado_civil: '',
    plano_valor: '49,90', plano_nome_plano: 'Mais Saúde',
    dependente1_nome: '', dependente1_data_nasc: '', dependente1_contato: '',
    dependente2_nome: '', dependente2_data_nasc: '', dependente2_contato: '',
    energia_nome: '', energia_cpf: '', energia_uc: '', energia_pn: '', energia_estado_civil: '', energia_conjuge: '',
    energia_rg: '', energia_celular: '', energia_email: ''
  });
  const [contractSigners, setContractSigners] = useState([
    { key: 'csigner-1', deliveryType: 'whatsapp', name: '', email: '', phone: '', documentation: '', birthday: '' }
  ]);
  const [contractTemplates, setContractTemplates] = useState([]);
  const [sendingContract, setSendingContract] = useState(false);
  const [buscandoCep, setBuscandoCep] = useState(false);

  const updateContractField = (key, value) => {
    setContractFields(prev => ({ ...prev, [key]: value }));
  };

  // ⭐ NOVO: busca endereço automaticamente pelo CEP (ViaCEP, gratuito)
  const handleCepBlur = async () => {
    const cep = contractFields.plano_cep.replace(/\D/g, '');
    if (cep.length !== 8) return;
    setBuscandoCep(true);
    try {
      const res = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await res.json();
      if (!data.erro) {
        setContractFields(prev => ({
          ...prev,
          plano_endereco: data.logradouro || prev.plano_endereco,
          plano_bairro: data.bairro || prev.plano_bairro,
          plano_cidade: data.localidade || prev.plano_cidade,
          // ⭐ Órgão Emissor não vem do CEP de verdade — usa "SSP/UF" como
          // sugestão mais comum, a pessoa pode corrigir se for diferente
          plano_orgao_emissor: prev.plano_orgao_emissor || (data.uf ? `SSP/${data.uf}` : prev.plano_orgao_emissor)
        }));
      }
    } catch (err) {
      console.error('Erro ao buscar CEP:', err);
    } finally {
      setBuscandoCep(false);
    }
  };

  // ⭐ NOVO: mantém o signatário sincronizado com os dados da Conta de Energia —
  // nome sempre igual, e email/telefone conforme o tipo de envio escolhido
  useEffect(() => {
    setContractSigners(prev => [{
      ...prev[0],
      name: contractFields.energia_nome,
      email: prev[0].deliveryType === 'email' ? contractFields.energia_email : prev[0].email,
      phone: prev[0].deliveryType === 'whatsapp' ? contractFields.energia_celular : prev[0].phone
    }]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractFields.energia_nome, contractFields.energia_email, contractFields.energia_celular]);

  const handleSignerDeliveryChange = (type) => {
    setContractSigners([{
      ...contractSigners[0],
      deliveryType: type,
      email: type === 'email' ? contractFields.energia_email : contractSigners[0].email,
      phone: type === 'whatsapp' ? contractFields.energia_celular : contractSigners[0].phone
    }]);
  };

  // ⭐ NOVO: botão "Titular Mesmo" — copia os dados do Plano pra Conta de Energia
  const handleTitularMesmo = () => {
    setContractFields(prev => ({
      ...prev,
      energia_nome: prev.plano_nome,
      energia_cpf: prev.plano_cpf,
      energia_rg: prev.plano_rg,
      energia_celular: prev.plano_celular,
      energia_estado_civil: prev.plano_estado_civil,
      energia_email: prev.plano_email
    }));
  };

  const loadContractTemplates = async () => {
    try {
      const res = await api.get('/api/esignature/templates');
      setContractTemplates(res.data);
    } catch (err) {
      console.error('Erro ao carregar modelos:', err);
    }
  };

  const handleTemplateUpload = async (templateType, file) => {
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('template_type', templateType);
    try {
      await api.post('/api/esignature/templates/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      alert(`Modelo de ${templateType === 'contrato' ? 'Contrato' : 'Autorização'} atualizado!`);
      loadContractTemplates();
    } catch (err) {
      alert('Erro ao enviar modelo: ' + (err.response?.data?.error || err.message));
    }
  };

  const handleSendContract = async (e) => {
    e.preventDefault();
    setSendingContract(true);
    try {
      await api.post('/api/esignature/send-contract', {
        fields: contractFields,
        signers: contractSigners.map(s => ({
          name: s.name, email: s.email, phone: s.phone,
          documentation: s.documentation, birthday: s.birthday, delivery_type: s.deliveryType
        }))
      });
      alert('Contrato preenchido e enviado pra assinatura!');
      loadSentDocs();
    } catch (err) {
      alert('Erro ao enviar contrato: ' + (err.response?.data?.error || err.message));
    } finally {
      setSendingContract(false);
    }
  };

  useEffect(() => {
    loadEsignConfig();
    loadPermission();
    loadSentDocs();
    loadContractTemplates();
  }, []);

  // ⭐ NOVO: assim que chega um aviso de "documento assinado", recarrega a lista sozinha
  useEffect(() => {
    if (notifications.length > 0 && notifications[0].type === 'esignature_signed') {
      loadSentDocs();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notifications]);

  const loadSentDocs = async () => {
    try {
      const res = await api.get('/api/esignature/list');
      setSentDocs(res.data);
    } catch (err) {
      console.error('Erro ao carregar lista de envios:', err);
    } finally {
      setLoadingList(false);
    }
  };

  // ⭐ NOVO: cancelar documento pendente
  const handleCancelDoc = async (doc) => {
    if (!window.confirm(`Cancelar o envio de "${doc.filename}"? Essa ação não pode ser desfeita.`)) return;
    try {
      await api.post(`/api/esignature/${doc.id}/cancel`);
      loadSentDocs();
    } catch (err) {
      alert('Erro ao cancelar documento: ' + (err.response?.data?.error || err.message));
    }
  };

  // ⭐ NOVO: baixar o PDF assinado
  const handleDownloadDoc = async (doc) => {
    try {
      const res = await api.get(`/api/esignature/${doc.id}/download`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', doc.filename || 'documento-assinado.pdf');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      alert('Erro ao baixar documento: ' + (err.response?.data?.error || err.message));
    }
  };

  const loadPermission = async () => {
    try {
      const res = await api.get('/api/profile/me');
      setCanAccess(res.data?.user?.can_access_envios !== false);
    } catch (err) {
      console.error('Erro ao verificar permissão de Envios:', err);
    }
  };

  const loadEsignConfig = async () => {
    try {
      const res = await api.get('/api/esignature/config');
      setEsignConfig(res.data);
    } catch (err) {
      console.error('Erro ao carregar configuração da Clicksign:', err);
    } finally {
      setLoadingConfig(false);
    }
  };

  const addEsignSigner = () => {
    setEsignSigners(prev => [...prev, {
      key: `signer-${Date.now()}`,
      deliveryType: 'email', name: '', email: '', phone: '', documentation: '', birthday: ''
    }]);
  };
  const removeEsignSigner = (key) => {
    setEsignSigners(prev => prev.filter(s => s.key !== key));
  };
  const updateEsignSigner = (key, field, value) => {
    setEsignSigners(prev => prev.map(s => s.key === key ? { ...s, [field]: value } : s));
  };

  const handleSendDocument = async (e) => {
    e.preventDefault();
    if (!esignFile) {
      alert('Selecione um arquivo PDF');
      return;
    }
    if (esignSigners.length === 0) {
      alert('Adicione pelo menos um signatário');
      return;
    }
    for (const s of esignSigners) {
      if (!s.name.trim()) {
        alert('Preencha o nome de todos os signatários');
        return;
      }
      if (s.deliveryType === 'whatsapp' && !s.phone.trim()) {
        alert(`Preencha o telefone (com DDD) de ${s.name || 'um signatário'} pro envio por WhatsApp`);
        return;
      }
      if (s.deliveryType === 'email' && !s.email.trim()) {
        alert(`Preencha o email de ${s.name || 'um signatário'} pro envio por Email`);
        return;
      }
    }
    setSendingDoc(true);
    try {
      const formData = new FormData();
      formData.append('file', esignFile);
      formData.append('signers', JSON.stringify(esignSigners.map(s => ({
        name: s.name,
        delivery_type: s.deliveryType,
        email: s.email || undefined,
        phone: s.phone || undefined,
        documentation: s.documentation || undefined,
        birthday: s.birthday || undefined
      }))));
      await api.post('/api/esignature/send', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      alert(`Documento enviado para assinatura! ${esignSigners.length > 1 ? `Os ${esignSigners.length} signatarios vao` : 'O signatario vai'} receber a solicitacao.`);
      setEsignFile(null);
      setEsignSigners([{ key: 'signer-1', deliveryType: 'email', name: '', email: '', phone: '', documentation: '', birthday: '' }]);
      loadSentDocs();
    } catch (err) {
      alert('Erro ao enviar documento: ' + (err.response?.data?.error || err.message));
    } finally {
      setSendingDoc(false);
    }
  };

  if (loadingConfig) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6 max-w-4xl">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-slate-100">Envios</h1>
        <p className="text-gray-500 dark:text-slate-400">Envie contratos e documentos para assinatura eletrônica</p>
      </div>

      {!canAccess ? (
        <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-2xl p-6 flex items-start gap-3">
          <AlertCircle size={20} className="text-red-600 dark:text-red-400 flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-red-800 dark:text-red-300">Você não tem acesso a essa tela</p>
            <p className="text-xs text-red-700 dark:text-red-400 mt-1">
              O envio de documentos para assinatura foi desativado pra você. Fale com o administrador ou gerente da empresa se precisar dessa permissão.
            </p>
          </div>
        </div>
      ) : !esignConfig?.configured ? (
        <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-2xl p-6 flex items-start gap-3">
          <AlertCircle size={20} className="text-amber-600 dark:text-amber-400 flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-amber-800 dark:text-amber-300">Assinatura digital ainda não configurada</p>
            <p className="text-xs text-amber-700 dark:text-amber-400 mt-1">
              Peça pra um administrador ou gerente configurar em Integração BI → Assinatura Digital antes de usar essa tela.
            </p>
          </div>
        </div>
      ) : (
        <div className="bg-white dark:bg-slate-800 rounded-2xl border border-gray-100 dark:border-slate-700 shadow-sm p-6">
          <div className="flex items-center gap-2 text-sm text-green-600 dark:text-green-400 mb-4">
            <CheckCircle2 size={16} />
            <span className="font-medium">
              Clicksign conectada ({esignConfig.environment === 'production' ? 'Produção' : 'Sandbox'})
            </span>
          </div>

          {/* ⭐ NOVO: abas — Formulário (preenche automaticamente) ou Arquivo pronto (upload manual) */}
          <div className="flex gap-2 mb-5 border-b border-gray-100 dark:border-slate-700">
            <button
              type="button"
              onClick={() => setEnvioTab('form')}
              className={`px-4 py-2 text-sm font-bold border-b-2 transition-colors ${
                envioTab === 'form' ? 'border-emerald-600 text-emerald-600 dark:text-emerald-400' : 'border-transparent text-gray-400 dark:text-slate-500 hover:text-gray-600'
              }`}
            >
              Preencher Formulário
            </button>
            <button
              type="button"
              onClick={() => setEnvioTab('upload')}
              className={`px-4 py-2 text-sm font-bold border-b-2 transition-colors ${
                envioTab === 'upload' ? 'border-emerald-600 text-emerald-600 dark:text-emerald-400' : 'border-transparent text-gray-400 dark:text-slate-500 hover:text-gray-600'
              }`}
            >
              Enviar Arquivo Pronto
            </button>
          </div>

          {envioTab === 'form' && (
          <div className="mb-6 pb-6">
            <h3 className="text-base font-bold text-gray-900 dark:text-slate-100 mb-1">Preencher Contrato e Autorização</h3>
            <p className="text-xs text-gray-500 dark:text-slate-400 mb-4">
              Preenche os dois modelos automaticamente com os dados abaixo, junta num PDF só (Contrato + Autorização) e manda pra assinatura.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4 p-3 bg-gray-50 dark:bg-slate-900 rounded-xl">
              {['contrato', 'autorizacao'].map(type => {
                const tpl = contractTemplates.find(t => t.template_type === type);
                return (
                  <div key={type}>
                    <p className="text-xs font-medium text-gray-600 dark:text-slate-300 mb-1">
                      Modelo do {type === 'contrato' ? 'Contrato' : 'Autorização'}
                    </p>
                    {tpl ? (
                      <p className="text-xs text-green-600 dark:text-green-400 mb-1">✓ {tpl.original_filename}</p>
                    ) : (
                      <p className="text-xs text-amber-600 dark:text-amber-400 mb-1">Nenhum arquivo enviado ainda</p>
                    )}
                    <input
                      type="file"
                      accept="application/pdf,image/*"
                      onChange={e => handleTemplateUpload(type, e.target.files[0])}
                      className="w-full text-xs text-gray-600 dark:text-slate-400"
                    />
                  </div>
                );
              })}
            </div>

            <form onSubmit={handleSendContract} className="space-y-4">
              {/* ⭐ NOVO: indicador de etapas */}
              <div className="flex items-center gap-2 text-xs font-bold text-gray-400 dark:text-slate-500 mb-1">
                <span className={contractStep === 1 ? 'text-emerald-600 dark:text-emerald-400' : ''}>1. Plano — Titular</span>
                <span>→</span>
                <span className={contractStep === 2 ? 'text-emerald-600 dark:text-emerald-400' : ''}>2. Conta de Energia + Assinatura</span>
              </div>

              {contractStep === 1 && (
                <div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    <input type="text" placeholder="Nome" value={contractFields.plano_nome}
                      onChange={e => updateContractField('plano_nome', e.target.value)}
                      className="w-full p-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-100" />
                    <input type="text" placeholder="Data de Nascimento" value={contractFields.plano_data_nascimento}
                      onChange={e => updateContractField('plano_data_nascimento', e.target.value)}
                      className="w-full p-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-100" />
                    <input type="text" placeholder="CPF" value={contractFields.plano_cpf}
                      onChange={e => updateContractField('plano_cpf', e.target.value)}
                      className="w-full p-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-100" />
                    <input type="text" placeholder="RG" value={contractFields.plano_rg}
                      onChange={e => updateContractField('plano_rg', e.target.value)}
                      className="w-full p-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-100" />
                    <div className="relative">
                      <input type="text" placeholder="CEP" value={contractFields.plano_cep}
                        onChange={e => updateContractField('plano_cep', e.target.value)}
                        onBlur={handleCepBlur}
                        className="w-full p-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-100" />
                      {buscandoCep && <span className="absolute right-2 top-2.5 text-[10px] text-gray-400">buscando...</span>}
                    </div>
                    <input type="text" placeholder="Órgão Emissor" value={contractFields.plano_orgao_emissor}
                      onChange={e => updateContractField('plano_orgao_emissor', e.target.value)}
                      className="w-full p-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-100" />
                    <input type="text" placeholder="Cidade (preenchida pelo CEP)" value={contractFields.plano_cidade}
                      onChange={e => updateContractField('plano_cidade', e.target.value)}
                      className="w-full p-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-100" />
                    <input type="text" placeholder="Endereço (preenchido pelo CEP)" value={contractFields.plano_endereco}
                      onChange={e => updateContractField('plano_endereco', e.target.value)}
                      className="w-full p-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-100" />
                    <input type="text" placeholder="Bairro (preenchido pelo CEP)" value={contractFields.plano_bairro}
                      onChange={e => updateContractField('plano_bairro', e.target.value)}
                      className="w-full p-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-100" />
                    <input type="text" placeholder="Celular" value={contractFields.plano_celular}
                      onChange={e => updateContractField('plano_celular', e.target.value)}
                      className="w-full p-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-100" />
                    <input type="email" placeholder="E-mail" value={contractFields.plano_email}
                      onChange={e => updateContractField('plano_email', e.target.value)}
                      className="w-full p-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-100" />
                    <input type="text" placeholder="Estado Civil" value={contractFields.plano_estado_civil}
                      onChange={e => updateContractField('plano_estado_civil', e.target.value)}
                      className="w-full p-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-100" />
                    <input type="text" placeholder="Valor do Plano (R$)" value={contractFields.plano_valor}
                      onChange={e => updateContractField('plano_valor', e.target.value)}
                      className="w-full p-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-100" />
                    <input type="text" placeholder="Nome do Plano (ex: Mais Saúde)" value={contractFields.plano_nome_plano}
                      onChange={e => updateContractField('plano_nome_plano', e.target.value)}
                      className="w-full p-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-100" />
                  </div>

                  <h4 className="text-sm font-bold text-gray-800 dark:text-slate-200 mb-2 mt-4">Dependentes (opcional)</h4>
                  {[1, 2].map(n => (
                    <div key={n} className="grid grid-cols-1 md:grid-cols-3 gap-2 mb-2">
                      <input type="text" placeholder={`Nome do Dependente ${n}`} value={contractFields[`dependente${n}_nome`]}
                        onChange={e => updateContractField(`dependente${n}_nome`, e.target.value)}
                        className="w-full p-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-100" />
                      <input type="text" placeholder="Data de Nascimento" value={contractFields[`dependente${n}_data_nasc`]}
                        onChange={e => updateContractField(`dependente${n}_data_nasc`, e.target.value)}
                        className="w-full p-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-100" />
                      <input type="text" placeholder="Contato" value={contractFields[`dependente${n}_contato`]}
                        onChange={e => updateContractField(`dependente${n}_contato`, e.target.value)}
                        className="w-full p-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-100" />
                    </div>
                  ))}

                  <button
                    type="button"
                    onClick={() => setContractStep(2)}
                    className="mt-4 w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-medium text-sm transition-colors"
                  >
                    Próximo →
                  </button>
                </div>
              )}

              {contractStep === 2 && (
                <div>
                  <button
                    type="button"
                    onClick={handleTitularMesmo}
                    className="text-xs font-bold text-blue-600 dark:text-blue-400 hover:underline mb-3"
                  >
                    ✓ Titular Mesmo (copiar dados do Plano pra Conta de Energia)
                  </button>

                  <h4 className="text-sm font-bold text-gray-800 dark:text-slate-200 mb-2">Conta de Energia — Titular</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
                    {[
                      ['energia_nome', 'Nome'], ['energia_cpf', 'CPF'], ['energia_uc', 'UC'], ['energia_pn', 'PN'],
                      ['energia_estado_civil', 'Estado Civil'], ['energia_conjuge', 'Cônjuge'],
                      ['energia_rg', 'RG'], ['energia_celular', 'Celular'], ['energia_email', 'E-mail']
                    ].map(([key, label]) => (
                      <input
                        key={key}
                        type="text"
                        placeholder={label}
                        value={contractFields[key]}
                        onChange={e => updateContractField(key, e.target.value)}
                        className="w-full p-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-100"
                      />
                    ))}
                  </div>

                  <h4 className="text-sm font-bold text-gray-800 dark:text-slate-200 mb-2">Signatário</h4>
                  <p className="text-xs text-gray-500 dark:text-slate-400 mb-2">
                    O nome e o contato são preenchidos automaticamente com os dados da Conta de Energia acima.
                  </p>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    <input type="text" placeholder="Nome" value={contractSigners[0].name} disabled
                      className="w-full p-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-800 rounded-lg text-sm text-gray-500 dark:text-slate-400" />
                    <select value={contractSigners[0].deliveryType}
                      onChange={e => handleSignerDeliveryChange(e.target.value)}
                      className="w-full p-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-100">
                      <option value="whatsapp">Enviar por WhatsApp</option>
                      <option value="email">Enviar por Email</option>
                    </select>
                    {contractSigners[0].deliveryType === 'whatsapp' ? (
                      <input type="text" placeholder="Telefone (preenchido pela Conta de Energia)" value={contractSigners[0].phone} disabled
                        className="w-full p-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-800 rounded-lg text-sm text-gray-500 dark:text-slate-400" />
                    ) : (
                      <input type="email" placeholder="Email (preenchido pela Conta de Energia)" value={contractSigners[0].email} disabled
                        className="w-full p-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-800 rounded-lg text-sm text-gray-500 dark:text-slate-400" />
                    )}
                  </div>

                  <div className="flex gap-2 mt-4">
                    <button
                      type="button"
                      onClick={() => setContractStep(1)}
                      className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 bg-gray-100 hover:bg-gray-200 dark:bg-slate-700 dark:hover:bg-slate-600 text-gray-700 dark:text-slate-200 rounded-xl font-medium text-sm transition-colors"
                    >
                      ← Voltar
                    </button>
                    <button
                      type="submit"
                      disabled={sendingContract}
                      className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50 text-white rounded-xl font-medium text-sm transition-colors"
                    >
                      <Send size={16} />
                      {sendingContract ? 'Enviando...' : 'Preencher e Enviar'}
                    </button>
                  </div>
                </div>
              )}
            </form>
          </div>
          )}

          {envioTab === 'upload' && (
          <form onSubmit={handleSendDocument} className="space-y-3">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">
                Documento (PDF) *
              </label>
              <input
                type="file"
                accept="application/pdf"
                onChange={e => setEsignFile(e.target.files[0] || null)}
                className="w-full text-sm text-gray-600 dark:text-slate-400"
              />
            </div>

            {esignSigners.map((signer, idx) => (
              <div key={signer.key} className="border border-gray-200 dark:border-slate-600 rounded-xl p-3 space-y-3">
                <div className="flex items-center justify-between">
                  <span className="text-xs font-semibold text-gray-500 dark:text-slate-400">
                    Signatario {idx + 1}
                  </span>
                  {esignSigners.length > 1 && (
                    <button
                      type="button"
                      onClick={() => removeEsignSigner(signer.key)}
                      className="text-xs text-red-600 dark:text-red-400 hover:underline"
                    >
                      Remover
                    </button>
                  )}
                </div>

                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">
                      Envio *
                    </label>
                    <select
                      value={signer.deliveryType}
                      onChange={e => updateEsignSigner(signer.key, 'deliveryType', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 dark:text-slate-100 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500 outline-none"
                    >
                      <option value="email">E-mail</option>
                      <option value="whatsapp">WhatsApp</option>
                    </select>
                  </div>
                  <div>
                    {signer.deliveryType === 'whatsapp' ? (
                      <>
                        <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">
                          Telefone (com DDD) *
                        </label>
                        <input
                          type="text"
                          value={signer.phone}
                          onChange={e => updateEsignSigner(signer.key, 'phone', e.target.value)}
                          className="w-full px-3 py-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 dark:text-slate-100 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500 outline-none"
                          placeholder="(11) 99999-9999"
                        />
                      </>
                    ) : (
                      <>
                        <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">
                          Email *
                        </label>
                        <input
                          type="email"
                          value={signer.email}
                          onChange={e => updateEsignSigner(signer.key, 'email', e.target.value)}
                          className="w-full px-3 py-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 dark:text-slate-100 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500 outline-none"
                          placeholder="joao@email.com"
                        />
                      </>
                    )}
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">
                    Nome do Signatario *
                  </label>
                  <input
                    type="text"
                    value={signer.name}
                    onChange={e => updateEsignSigner(signer.key, 'name', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 dark:text-slate-100 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500 outline-none"
                    placeholder="Ex: Joao Silva"
                  />
                </div>

                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">
                      CPF (opcional)
                    </label>
                    <input
                      type="text"
                      value={signer.documentation}
                      onChange={e => updateEsignSigner(signer.key, 'documentation', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 dark:text-slate-100 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500 outline-none"
                      placeholder="000.000.000-00"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">
                      Data de Nascimento (opcional)
                    </label>
                    <input
                      type="date"
                      value={signer.birthday}
                      onChange={e => updateEsignSigner(signer.key, 'birthday', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-200 dark:border-slate-600 dark:bg-slate-700 dark:text-slate-100 rounded-xl text-sm focus:ring-2 focus:ring-emerald-500 outline-none"
                    />
                  </div>
                </div>
              </div>
            ))}

            <button
              type="button"
              onClick={addEsignSigner}
              className="w-full py-2 border border-dashed border-emerald-400 dark:border-emerald-600 text-emerald-700 dark:text-emerald-400 rounded-xl text-sm font-medium hover:bg-emerald-50 dark:hover:bg-emerald-900/20"
            >
              + Adicionar pessoa
            </button>
            <button
              type="submit"
              disabled={sendingDoc}
              className="w-full py-2 bg-emerald-600 text-white rounded-xl text-sm font-medium hover:bg-emerald-700 disabled:opacity-50 flex items-center justify-center gap-2"
            >
              <Send size={16} />
              {sendingDoc ? 'Enviando...' : 'Enviar para Assinatura'}
            </button>
          </form>
          )}
        </div>
      )}

      {/* ⭐ NOVO: histórico de envios com status */}
      <div className="bg-white dark:bg-slate-800 rounded-2xl border border-gray-100 dark:border-slate-700 shadow-sm overflow-hidden">
        <div className="p-5 border-b border-gray-100 dark:border-slate-700">
          <h2 className="text-lg font-bold text-gray-900 dark:text-slate-100">Histórico de Envios</h2>
          <p className="text-sm text-gray-500 dark:text-slate-400">Acompanhe o status de cada documento enviado</p>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead className="bg-gray-50 dark:bg-slate-900 border-b border-gray-200 dark:border-slate-700">
              <tr>
                <th className="px-4 py-3 text-xs font-semibold text-gray-500 dark:text-slate-400 uppercase tracking-wider">Documento</th>
                <th className="px-4 py-3 text-xs font-semibold text-gray-500 dark:text-slate-400 uppercase tracking-wider">Signatário(s)</th>
                <th className="px-4 py-3 text-xs font-semibold text-gray-500 dark:text-slate-400 uppercase tracking-wider">Status</th>
                <th className="px-4 py-3 text-xs font-semibold text-gray-500 dark:text-slate-400 uppercase tracking-wider">Enviado por</th>
                <th className="px-4 py-3 text-xs font-semibold text-gray-500 dark:text-slate-400 uppercase tracking-wider">Data</th>
                <th className="px-4 py-3 text-xs font-semibold text-gray-500 dark:text-slate-400 uppercase tracking-wider text-center">Ações</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100 dark:divide-slate-700">
              {loadingList ? (
                <tr>
                  <td colSpan={6} className="px-6 py-10 text-center">
                    <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-emerald-600 mx-auto"></div>
                  </td>
                </tr>
              ) : sentDocs.length === 0 ? (
                <tr>
                  <td colSpan={6} className="px-6 py-10 text-center">
                    <FileText size={40} className="mx-auto text-gray-300 dark:text-slate-600 mb-2" />
                    <p className="text-gray-500 dark:text-slate-400 text-sm">Nenhum documento enviado ainda</p>
                  </td>
                </tr>
              ) : (
                sentDocs.map(doc => (
                  <tr key={doc.id} className="hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors">
                    <td className="px-4 py-3 text-sm font-medium text-gray-900 dark:text-slate-100">{doc.filename}</td>
                    <td className="px-4 py-3 text-sm text-gray-600 dark:text-slate-400">
                      {(doc.signers || []).map(s => s.name).join(', ')}
                    </td>
                    <td className="px-4 py-3">
                      {doc.status === 'signed' ? (
                        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400">
                          <CheckCircle2 size={12} />
                          Assinado
                        </span>
                      ) : doc.status === 'canceled' ? (
                        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold bg-gray-100 text-gray-500 dark:bg-slate-700 dark:text-slate-400">
                          <XCircle size={12} />
                          Cancelado
                        </span>
                      ) : (
                        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400">
                          <Clock size={12} />
                          Pendente
                        </span>
                      )}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-600 dark:text-slate-400">{doc.created_by_name || '-'}</td>
                    <td className="px-4 py-3 text-sm text-gray-500 dark:text-slate-400">
                      {new Date(doc.created_at).toLocaleDateString('pt-BR')}
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex items-center justify-center gap-2">
                        {/* ⭐ NOVO: só mostra Cancelar se ainda estiver pendente */}
                        {doc.status === 'pending' && (
                          <button
                            onClick={() => handleCancelDoc(doc)}
                            title="Cancelar documento"
                            className="p-1.5 text-gray-400 hover:text-red-600 dark:hover:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors"
                          >
                            <XCircle size={16} />
                          </button>
                        )}
                        {/* ⭐ NOVO: só mostra Baixar se já estiver assinado, e fica
                            transparente/desabilitado depois de 24h da assinatura */}
                        {doc.status === 'signed' && (() => {
                          const hoursSinceSigned = doc.signed_at ? (Date.now() - new Date(doc.signed_at).getTime()) / (1000 * 60 * 60) : Infinity;
                          const expired = hoursSinceSigned > 24;
                          return expired ? (
                            <span
                              title="Prazo de 24h pra baixar expirou — o PDF foi enviado por email quando foi assinado"
                              className="p-1.5 text-gray-300 dark:text-slate-600 opacity-40 cursor-not-allowed"
                            >
                              <Download size={16} />
                            </span>
                          ) : (
                            <button
                              onClick={() => handleDownloadDoc(doc)}
                              title="Baixar documento assinado"
                              className="p-1.5 text-gray-400 hover:text-emerald-600 dark:hover:text-emerald-400 hover:bg-emerald-50 dark:hover:bg-emerald-900/20 rounded-lg transition-colors"
                            >
                              <Download size={16} />
                            </button>
                          );
                        })()}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Envios;
